import React from 'react';

export const PlusSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
  </svg>
);

export default PlusSvg;
